const blackStarsQatarTNC = {
  header: "PULSE & CHILL TRIVIA (DIGITAL) TERMS AND CONDITIONS",
  body: [
    {
      title: "ELIGIBILITY",
      details: `MTN Pulse subscribers who use Smartphones across Ghana are eligible to participate in this digitally-oriented football ticket trivia.`,
    },
    {
      title: ``,
      details: `There will be no opt in by way of USSD channel to participate in the trivia.`,
    },
    {
      title: ``,
      details: `Participants must have at least a six (6) month valid Passport and should be willing to travel alone.`,
    },

    {
      title: `TERMS`,
      details: `Trivia will take place within the 4th week of November 2022.`,
    },

    {
      title: ``,
      details: `Eligible participants are to answer ALL questions correctly at a go to stand a chance to win a ticket to support the Black Stars in the football tournament.`,
    },
    {
      title: ``,
      details: `Eligible participants have up to two chances to answer the Trivia.`,
    },
    {
      title: ``,
      details: `Eligible participants will receive an In-App notification.`,
    },
    {
      title: ``,
      details: `Winning the Trivia does not give Participant an automatic selection for a travel ticket.`,
    },
    {
      title: ``,
      details: `Ticket won is not transferable.`,
    },
    {
      title: ``,
      details: `Ticket admits only the Participant.`,
    },
    {
      title: ``,
      details: `Eligible winners will watch only One Ghana match in the football tournament.`,
    },
    {
      title: ``,
      details: `SIMs dedicated solely for commercial transactions by Mobile Money merchants are exempted from this Trivia.`,
    },
    {
      title: ``,
      details: `MTN Staff and their spouses as well as third party agents are exempted from this Trivia.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to disqualify a winner when it is proven that the winner used any fraudulent means to participate in the Trivia. Such customers will be handed over to the police to face the law.`,
    },
    {
      title: ``,
      details: `MTN reserves the right to alter the Terms and Conditions at any point in time.`,
    },
    {
      title: ``,
      details: `The duration can be extended whenever MTN deems it appropriate.`,
    },
    {
      title: ``,
      details: `Personal customer information of partcipants will not be published publicly in line with data privacy and protection.`,
    },
    {
      title: ``,
      details: `All other Terms and Conditions of our Travel Partner(s) will be applicable.`,
    },
    {
      title: ``,
      details: `Winners will be notified by MTN authorized personnel and via the number 0244 300 000 ONLY.`,
    },
    {
      title: `PERSONAL DATA PROTECTION`,
      details: `By enjoying this loyalty scheme, the Customer expressly agree that personal data which they supply shall be processed by MTN for the purpose of executing the loyalty scheme and also for the purpose of visa acquisition and travelling processes, publicizing the scheme and MTN. It is hereby specified that MTN guarantees that publicity, entailing the sharing with third parties of personal data supplied as a result of participation in the loyalty scheme, (including through television, the press, leaflets, social media and other means and format of communication) shall be made only with respect to the participants of the scheme and will only indicate the given names and surnames of the participants, their images and voices, made for the sole purpose of publicity connected to the loyalty scheme). Participation in the loyalty scheme shall be deemed as participants express consent for the use of this data in the manner herein defined.`,
    },
    {
      title: ``,
      details: `Notwithstanding the above, personal data of the participation will be retained by MTN in accordance with the law and will share with only the approved Travel Agency. MTN respects the privacy of Participants of this loyalty scheme and accordingly personal data collected during this promo will be treated as private and confidential and in accordance with Data Protection laws of Ghana.`,
    },
    {
      title: `DISCLAIMER`,
      details: `MTN is not liable for any losses or damages or harm that may arise as a result of this loyalty scheme. Selected Winners are responsible for fully adhering to all protocols (COVID-19, etc.) required by the Host country, Airline, and approved Travel Agency.`,
    },
  ],
};

export default blackStarsQatarTNC;
